import { useEffect, useState } from "react";
import Loading from "../Components/Loading";
import * as api from "../api/api";
import { Modal, Form, Button } from "react-bootstrap";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import checkAuthorization from "../config/checkAuth";
import { Snackbar, Alert } from "@mui/material";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";

export default function AdminTenantIdle() {
  const { language } = useLanguage();
  const pageTitle = "AdminTenantIdle";
  const [isLoading, setIsLoading] = useState(true);
  const [tenantIdles, setTenantIdles] = useState([]);
  const [snackbarData, setSnackbarData] = useState({});
  const [idleCodeNames, setIdleCodeNames] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [validatedAddTenantIdle, setValidatedAddTenantIdle] = useState(false);
  const [addTenantIdleData, setAddTenantIdleData] = useState({
    stopsActivity: false,
    isBillable: false,
    masterIdle: {},
  });
  const [showIsEditingModal, setShowIsEditingModal] = useState(false);
  const [selectedForEdit, setSelectedForEdit] = useState({});
  const [validatedEdit, setValidatedEdit] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [toBeDeleted, setToBeDeleted] = useState({});

  let idleCodeToName = new Map();

  const navigate = useNavigate();

  async function getAllTenantIdles() {
    api
      .getAllTenantIdles()
      .then((response) => {
        setTenantIdles(response.data.object);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getIdleCodeNames() {
    api.getAllMasterIdles().then((response) => {
      setIdleCodeNames(response.data.object);
      setAddTenantIdleData({
        ...addTenantIdleData,
        masterIdle: { masterIdleId: response?.data?.object[0]?.masterIdleId },
      });
    });
  }

  function matchIdToName() {
    tenantIdles.forEach((idle) => {
      let id = idle.idleId;
      idleCodeNames.forEach((name) => {
        if (id === name.idleId) {
          idleCodeToName.set(id, name.name);
        }
      });
    });
  }

  function handleClose(item) {
    if (item === "AddModal") {
      setShowAddModal(false);
    } else if (item === "EditModal") {
      setShowIsEditingModal(false);
    }
  }

  function modifyNewTenantIdleData(propName, data) {
    let change = addTenantIdleData;
    let internalIdleCodeToName = new Map();
    idleCodeNames.forEach((item) => {
      internalIdleCodeToName.set(item.masterIdleId, item.name);
    });

    function getByValue(map, searchValue) {
      for (let [key, value] of map.entries()) {
        if (value === searchValue) return key;
      }
    }

    if (propName === "masterIdle") {
      change = {
        ...change,
        masterIdle: { masterIdleId: Number(data) },
      };
      console.log(change);
    } else {
      change = {
        ...change,
        [propName]: data,
      };
      console.log(propName, data, addTenantIdleData);
    }

    setAddTenantIdleData(change);
  }

  function addNewTenantIdle(event) {
    const form = event.currentTarget;

    if (form.checkValidity() == false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setValidatedAddTenantIdle(true);
      event.preventDefault();
      api
        .postNewTenantIdle(addTenantIdleData)
        .then((response) => {
          if (
            response.data.statusCode == 400 ||
            response.data.statusCode == 500
          ) {
            //error
            console.log("Error adding tenant idle");
          } else {
            setSnackbarData({
              ...snackbarData,
              message: strings[pageTitle][language].successSnackbar,
              severity: "success",
              show: true,
            });
            setAddTenantIdleData({
              stopsActivity: false,
              isBillable: false,
              masterIdle: {},
            });
            handleClose("AddModal");
            getAllTenantIdles();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  function getNameByValue(map, searchValue) {
    for (let [key, value] of map.entries()) {
      if (value === searchValue) return key;
    }
  }

  function modifyEditingTenantData(propName, data) {
    let internalIdleCodeToName = new Map();
    idleCodeNames.forEach((item) => {
      internalIdleCodeToName.set(item.idleId, item.name);
    });

    if (propName === "name") {
      setSelectedForEdit({
        ...selectedForEdit,
        masterIdle: { masterIdleId: data },
      });
    } else {
      setSelectedForEdit({ ...selectedForEdit, [propName]: data });
    }
  }

  function editTenantIdle(event) {
    const form = event.currentTarget;
    if (form.checkValidity() == false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setValidatedEdit(true);
      event.preventDefault();
      api
        .modifyTenantIdleById(selectedForEdit)
        .then((response) => {
          if (
            response.data.statusCode == 500 ||
            response.data.statusCode == 400
          ) {
            // error
            setSnackbarData({
              ...snackbarData,
              message: strings[pageTitle][language].duplicatedIdleCodeSnackbar,
              severity: "error",
              show: true,
            });
          } else {
            getAllTenantIdles();
            setSnackbarData({
              ...snackbarData,
              message: strings[pageTitle][language].successEditSnackbar,
              severity: "success",
              show: true,
            });
            setSelectedForEdit({});
            handleClose("EditModal");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  function confirmDelete(event) {
    event.preventDefault();

    api
      .deleteTenantIdleById(toBeDeleted.tenantIdleId)
      .then((response) => {
        setShowDeleteModal(false);
        getAllTenantIdles();
        setSnackbarData({
          ...snackbarData,
          message: strings[pageTitle][language].successDeleteSnackbar,
          severity: "success",
          show: true,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    checkAuthorization("TENANT_IDLE").then((result) => {
      if (result) {
        getAllTenantIdles();
        getIdleCodeNames();
        //matchIdToName();
        setIsLoading(false);
      } else {
        navigate("/unauthorized");
      }
    });
  }, []);

  return isLoading ? (
    <Loading></Loading>
  ) : (
    <div className="main-content">
      <p className="main-content__title">
        {strings[pageTitle][language].pageName}
      </p>
      <hr className="main-content-title__hr" />

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackbarData.show}
        autoHideDuration={3000}
        onClose={() => setSnackbarData({ ...snackbarData, show: false })}
      >
        <Alert severity={snackbarData.severity} sx={{ width: "100%" }}>
          {snackbarData.message}
        </Alert>
      </Snackbar>

      <button
        className="button-normal"
        style={{ alignSelf: "flex-end", margin: "1em" }}
        onClick={() => {
          setShowAddModal(true);
        }}
      >
        {strings[pageTitle][language].add}
      </button>
      <table>
        <thead>
          <tr>
            <th>{strings[pageTitle][language].tableHeaders[0]}</th>
            <th>{strings[pageTitle][language].tableHeaders[1]}</th>
            <th>{strings[pageTitle][language].tableHeaders[2]}</th>
            <th>{strings[pageTitle][language].tableHeaders[3]}</th>
            <th>{strings[pageTitle][language].tableHeaders[4]}</th>
          </tr>
        </thead>
        <tbody>
          {tenantIdles.map((idle) => {
            matchIdToName();
            return (
              <tr key={idle.tenantIdleId}>
                <td>{idle.masterIdle.name}</td>
                <td> {idle.ctiId}</td>
                <td>
                  {idle.stopsActivity === true
                    ? strings[pageTitle][language].yes
                    : strings[pageTitle][language].no}
                </td>
                <td>
                  {idle.isBillable === true
                    ? strings[pageTitle][language].yes
                    : strings[pageTitle][language].no}
                </td>
                <td>
                  <button
                    style={{
                      border: "none",
                      outline: "none",
                      backgroundColor: "rgba(255, 0, 0, 0)",
                      color: "#00a0e5",
                    }}
                    onClick={() => {
                      setSelectedForEdit(idle);
                      setShowIsEditingModal(true);
                      console.log(idle);
                    }}
                  >
                    <EditIcon></EditIcon>
                  </button>
                  <button
                    style={{
                      border: "none",
                      outline: "none",
                      backgroundColor: "rgba(255, 0, 0, 0)",
                      color: "#00a0e5",
                    }}
                    onClick={() => {
                      setShowDeleteModal(true);
                      setToBeDeleted(idle);
                    }}
                  >
                    <DeleteIcon></DeleteIcon>
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <Modal
        show={showAddModal}
        onHide={() => {
          handleClose("AddModal");
        }}
      >
        <Form
          onSubmit={addNewTenantIdle}
          noValidate
          validated={validatedAddTenantIdle}
        >
          <Modal.Body>
            {strings[pageTitle][language].addModalBody}
            <Form.Group className="mb-3">
              <Form.Label>
                {strings[pageTitle][language].modalLabels[0]}
              </Form.Label>
              <Form.Select
                placeholder="Select Idle Code"
                autoFocus
                onChange={(event) => {
                  console.log(event.target.value);
                  modifyNewTenantIdleData("masterIdle", event.target.value);
                }}
                required
                type="text"
                defaultValue={idleCodeNames[0]}
              >
                {idleCodeNames.map((item) => {
                  return (
                    <option key={item.masterIdleId} value={item.masterIdleId}>
                      {item.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                {strings[pageTitle][language].modalLabels[1]}
              </Form.Label>
              <Form.Control
                placeholder=""
                onChange={(event) =>
                  modifyNewTenantIdleData("ctiId", event.target.value)
                }
                required
                type="text"
              ></Form.Control>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>
                {strings[pageTitle][language].modalLabels[2]}
              </Form.Label>
              <Form.Check
                placeholder=""
                onChange={(event) =>
                  modifyNewTenantIdleData("stopsActivity", event.target.checked)
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>
                {strings[pageTitle][language].modalLabels[3]}
              </Form.Label>
              <Form.Check
                placeholder=""
                onChange={(event) =>
                  modifyNewTenantIdleData("isBillable", event.target.checked)
                }
              />
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                setShowAddModal(false);
                setValidatedAddTenantIdle(false);
              }}
            >
              {strings[pageTitle][language].cancel}
            </Button>
            <Button variant="primary" type="submit">
              {strings[pageTitle][language].add}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        show={showIsEditingModal}
        onHide={() => {
          handleClose("EditModal");
        }}
      >
        <Form onSubmit={editTenantIdle} noValidate validated={validatedEdit}>
          <Modal.Body>
            {strings[pageTitle][language].editModalBody}
            <Form.Group className="mb-3">
              <Form.Label>
                {strings[pageTitle][language].modalLabels[0]}
              </Form.Label>
              <Form.Select
                placeholder=""
                autoFocus
                onChange={(event) => {
                  console.log(event.target.value);
                  modifyEditingTenantData("name", event.target.value);
                }}
                required
                type="text"
                value={selectedForEdit?.masterIdle?.masterIdleId}
              >
                {idleCodeNames.map((item) => {
                  return (
                    <option key={item.masterIdleId} value={item.masterIdleId}>
                      {item.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                {strings[pageTitle][language].modalLabels[1]}
              </Form.Label>
              <Form.Control
                placeholder=""
                onChange={(event) =>
                  modifyEditingTenantData("ctiId", event.target.value)
                }
                required
                type="text"
                defaultValue={selectedForEdit.ctiId}
              ></Form.Control>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>
                {strings[pageTitle][language].modalLabels[2]}
              </Form.Label>
              <Form.Check
                placeholder=""
                onChange={(event) =>
                  modifyEditingTenantData("stopsActivity", event.target.checked)
                }
                defaultChecked={selectedForEdit.stopsActivity}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>
                {strings[pageTitle][language].modalLabels[3]}
              </Form.Label>
              <Form.Check
                placeholder=""
                onChange={(event) =>
                  modifyEditingTenantData("isBillable", event.target.checked)
                }
                defaultChecked={selectedForEdit.isBillable === true}
              />
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                handleClose("EditModal");
              }}
            >
              {strings[pageTitle][language].cancel}
            </Button>
            <Button variant="primary" type="submit">
              {strings[pageTitle][language].confirmEdit}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={showDeleteModal}>
        <Modal.Header>
          <Modal.Title>
            {strings[pageTitle][language].deleteModalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{strings[pageTitle][language].deleteModalBody}</p>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                setShowDeleteModal(false);
                setToBeDeleted({});
              }}
            >
              {strings[pageTitle][language].cancel}
            </Button>
            <Button variant="danger" onClick={(event) => confirmDelete(event)}>
              {strings[pageTitle][language].confirm}
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </div>
  );
}
